import {
  PowerBIAnalytics,
  PremiumAnalyticsPages,
} from "@components/analytics/power-bi/power-bi-analytics";

/** Renders project analytics under projects tab in analytics*/
export function ProjectsAnalytics(): JSX.Element {
  return <PowerBIAnalytics pageDisplayName={PremiumAnalyticsPages.projects} />;
}
